var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoOther = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44928",
    "data-name": "Group 44928",
    transform: "translate(-1243 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Other",
    "data-name": "icon/Other",
    transform: "translate(6153.615 13258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14086",
    "data-name": "Rectangle 14086",
    width: 24,
    height: 24,
    transform: "translate(-4910.615 -12397)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_Other-2",
    "data-name": "icon/Other",
    d: "M291.133,364.9l-2.886-2.886a1.166,1.166,0,0,1,0-1.647l2.886-2.886a1.166,1.166,0,0,1,1.647,0l2.886,2.886a1.165,1.165,0,0,1,0,1.647L292.78,364.9A1.163,1.163,0,0,1,291.133,364.9Zm-11.9,0-2.885-2.886a1.163,1.163,0,0,1,0-1.647l2.885-2.886a1.166,1.166,0,0,1,1.647,0l2.886,2.886a1.163,1.163,0,0,1,0,1.647l-2.885,2.886A1.165,1.165,0,0,1,279.233,364.9Zm5.95-5.955-2.885-2.881a1.164,1.164,0,0,1,0-1.647l2.885-2.886a1.165,1.165,0,0,1,1.648,0l2.885,2.886a1.164,1.164,0,0,1,0,1.647l-2.885,2.881A1.164,1.164,0,0,1,285.184,358.948Zm0,11.9-2.886-2.884a1.163,1.163,0,0,1,0-1.647l2.885-2.886a1.165,1.165,0,0,1,1.648,0l2.885,2.886a1.165,1.165,0,0,1,0,1.647l-2.886,2.884A1.162,1.162,0,0,1,285.184,370.851Z",
    transform: "translate(-5185.007 -12746.191)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoOther);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_other.2f0bf5078297de90d3f35bd8b8c684cd.svg";